<template>
  <v-dialog :value="Boolean(value)" persistent max-width="560">
    <v-card v-if="value">
      <v-card-title>{{ value.title }}</v-card-title>
      <v-card-text>
        {{ value.message }}
        <v-expansion-panels v-if="technicalDetails.length" flat class="mt-4">
          <v-expansion-panel>
            <v-expansion-panel-header>Technical details</v-expansion-panel-header>
            <v-expansion-panel-content>
              <div v-for="detail in technicalDetails" :key="detail.label">
                <strong>{{ detail.label }}:</strong> {{ detail.value }}
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="value.applicationId" color="#006c27" class="white--text" @click="$emit('open-application', value.applicationId)">
          Open application
        </v-btn>
        <v-btn color="#006c27" class="white--text" @click="$emit('close')">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ApplicationCreationResultDialog",
  props: {
    value: Object,
  },
  computed: {
    technicalDetails() {
      if (!this.value) {
        return [];
      }
      return [
        ["Message", this.value.publicMessage],
        ["Error code", this.value.errorCode],
        ["HTTP status", this.value.status],
        ["Request ID", this.value.requestId],
        ["Operation ID", this.value.operationId],
      ]
        .filter(([, value]) => value !== undefined && value !== null && value !== "")
        .map(([label, value]) => ({ label, value }));
    },
  },
};
</script>
